import { Input, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
/** 🔹 Component Map */
const CustomInputs: {
  nodePicker: any;
  languageInput: any;
} = {
  nodePicker: ({ field }: any) => (
    <Input
      readOnly
      placeholder={field.placeholder}
      onClick={field.onClick}
      suffix={
        <Tooltip title={field.tooltip}>
          <InfoCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
        </Tooltip>
      }
    />
  ),

  languageInput: ({ field }: any) => (
    <Input
      // onChange={(e) =>
      //   field.handleSearchLanguage?.(
      //     e.target.value.replace(/\s+/g, "")
      //   )
      // }
      suffix={
        <Tooltip title={field.tooltip}>
          <InfoCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
        </Tooltip>
      }
    />
  ),
};

export default CustomInputs;
